import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import { Notification } from 'bloomer'

import Image from './image'
import press from '../content/press'

export default () => {
  const data = useStaticQuery(graphql`
    query {
      marketscale: file(relativePath: { eq: "assets/press/marketscale.jpg" }) {
        ...FixedImage
      }
      adonrigg: file(relativePath: { eq: "assets/press/adonrigg.jpg" }) {
        ...FixedImage
      }
      alphahippie: file(relativePath: { eq: "assets/press/alphahippie.png" }) {
        ...FixedImage
      }
      contractorinnovation: file(relativePath: { eq: "assets/press/contractor-innovation.jpg" }) {
        ...FixedImage
      }
      press1871: file(relativePath: { eq: "assets/press/1871-logo.png" }) {
        ...FixedImage
      }
      builtin: file(relativePath: { eq: "assets/press/built-in-chicago-logo.png" }) {
        ...FixedImage
      }
      catapult: file(relativePath: { eq: "assets/press/catapult-program-logo-square.png" }) {
        ...FixedImage
      }
      tastytrade: file(relativePath: { eq: "assets/press/tasty-trade-logo.png" }) {
        ...FixedImage
      }
    }
  `)

  const Press = Object.keys(data).map(key => {
    const image = data[key]

    return (
      <Notification key={key} isColor={'white'} style={{ marginTop: 30 }}>
        <a href={press[key].url} target={'_blank'} rel="noopener noreferrer">
          <Image alt={press[key].headline} file={image} />
          <br />
          {press[key].headline}
        </a>
      </Notification>
    )
  })

  return Press
}
